export const SVG_NAMESPACE = "http://www.w3.org/2000/svg";

export const TAB_LOADER_SPINNER = {
  SIZE_PX: 40,
  CIRCLE_BOX: 44,
  CIRCLE_THICKNESS: 3.6,
  CIRCLE_DASH_ARRAY: "80px, 200px",
  WRAPPER_TURN_MS: 1000,
  CIRCLE_TURN_MS: 1400,
};

export const TAB_LOADER_LAYOUT = {
  GAP_PX: 16,
  BACKGROUND_COLOR: "#fff",
  TEXT_COLOR: "#555",
  FONT: "16px Roboto, Arial, sans-serif",
};
